import React, { FC, useEffect, useState } from "react";
import cancel from "../../assets/images/cancel.svg";
import edit from "../../assets/images/edit_round.svg";
import user from "../../assets/images/single_bill.svg";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store";
import DocumentPreViewer from "../../components/commons/document-preview";
import {
  getCurrencyNumberWithSymbol,
  getMaskedMobileNumber,
} from "../../helpers/get-currency-number";
import moment from "moment";
import { toast } from "react-toastify";
import useAxiosClient from "../../hooks/useAxiosClient";
import Modal from "../../components/ui/modal";
import ModalHeader from "../../components/ui/modal/modal-header";
import {
  Button,
  Input,
  PanelSlider,
  Popover,
  Select2,
} from "../../components/ui";
import { updateRefresh } from "../../reducers/tradeSlice";
import {
  getPaymentStatus,
  getPaymentStatusColor,
} from "../../helpers/getPaymentStatus";
import { pdf, PDFDownloadLink } from "@react-pdf/renderer";
import download from "../../assets/images/download_pdf.svg";
import {
  clearArrivalDocs,
  setOpenArrivalPmtEdit,
  updateEditAdvPayment,
} from "../../reducers/arrivalDetails_slice";
import TransportPmtHistoty from "../trade-detail_v2/payment_details/transport_pmt_history";
import { enableExcessPayment } from "../../helpers/getText";
import TransportPmtEdit from "../trade-detail_v2/payment_details/TransportPmtEdit";
import cancelIcon from "../../assets/images/close.svg";
import move from "../../assets/images/move.svg";
import MovePayment from "../trade-detail_v2/payment_details/move_payment";
import useMovePayment from "../../hooks/trade_detail/useMovePayment";
import {
  resetMovePayment,
  setIsPaymentHistoryMove,
  setRefreshMovePmt,
} from "../../reducers/trade_details_Slice";
import PaymentRecDocs from "./paymentRecDocs";
import { useUIPermissions } from "../../layout/config/permissionUtils";

const PaymentHistory: FC<{
  traderId: number;
  tradeId: number;
  onClose: (paymentDone: boolean) => void;
  recordType?: string;
  onEdit: (isEdit: boolean) => void;
  role: string;
  refundedTotal?: number;
}> = ({
  traderId,
  tradeId,
  onClose,
  recordType,
  onEdit,
  role,
  refundedTotal = 0,
}) => {
  const {
    paymentHistoryObj,
    paymentUpdateStatus,
    tradeDetailsbyId,
    adminId,
    refresh,
    selectedPaymentType,
    editAdvancePayment,
    arrivalpmtHistory,
    openTransportPmtEdit,
    isPaymentHistoryMove,
  } = useSelector((state: TRootState) => ({
    paymentHistoryObj: state.arrivalDetails.paymentHistoryObj,
    paymentUpdateStatus: state.trades.paymentUpdateStatus,
    tradeDetailsbyId: state.tradeDetailsById.tradeDetailsbyId,
    adminId: state.auth.adminId,
    refresh: state.trades.refresh,
    selectedPaymentType: state.paymentDetails.selectedPaymentType,
    editAdvancePayment: state.arrivalDetails.editAdvancePayment,
    arrivalpmtHistory: state.arrivalDetails.arrivalpmtHistory,
    openTransportPmtEdit: state.arrivalDetails.openTransportPmtEdit,
    isPaymentHistoryMove: state.tradeDetails.isPaymentHistoryMove,
  }));
  const { hasAdminManagerEditAccess } = useUIPermissions();
  const dispatch = useDispatch();
  const { handlePostCall } = useAxiosClient();

  const [cancelPopup, setCancelPopup] = useState(false);
  const [openCalender, setOpenCalendar] = useState(false);

  const [cancellationReason, setCancellationReason] = useState<string>("");

  const cancelRecordPayment = () => {
    if (!cancellationReason) {
      toast.error("Please select reason for cancellation");
      return;
    }
    handlePostCall({
      URL: "admin/trade-platform/trades/payments",
      apiParams: {
        action: "CANCEL",
        adminId: adminId,
        amount: paymentHistoryObj?.amount,
        date: moment(paymentHistoryObj?.date).format("YYYY-MM-DD"),
        images: [],
        inOutWard: paymentHistoryObj?.inOutWard,
        pmtMode: paymentHistoryObj?.pmtMode,
        pmtType: paymentHistoryObj?.pmtType,
        tradeId: tradeId,
        traderId: traderId,
        id: paymentHistoryObj?.id,
        status: 0,
        comments: paymentHistoryObj?.comments || "",
        reqAdv: {
          advApproved: adminId,
          advDisb: paymentHistoryObj?.amount,
          disbDate: moment(paymentHistoryObj?.date).format("YYYY-MM-DD"),
          tradeId: tradeId,
        },
        pmtReceiptDate: paymentHistoryObj?.pmtReceiptDate
          ? moment(paymentHistoryObj?.pmtReceiptDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        utr: paymentHistoryObj?.utr,
        desc: paymentHistoryObj?.desc,
        rejectedReason: cancellationReason,
        addtComments: additionalComments,
        pmtStatus: "CANCELLED",
        pf: tradeDetailsbyId?.destPf,
        delayCharges: tradeDetailsbyId?.destDelayCharges || "",
      },
    }).then(({ data }) => {
      toast.success("Cancelled successfully");
      dispatch(updateRefresh({ refresh: !refresh }));
      dispatch(setRefreshMovePmt(true));
      setCancelPopup(false);
      onClose(false);
    });
  };

  const [additionalComments, setAdditionalComments] = useState("");

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    const generatePreview = async () => {
      const blob = await pdf(
        <PaymentRecDocs
          details={paymentHistoryObj}
          type={""}
          status={"single"}
          seqId={tradeId}
        />,
      ).toBlob();
      if (!blob) {
        console.error("Failed to generate PDF Blob");
        return;
      }

      const url = URL.createObjectURL(blob);
      setPreviewUrl(url);
    };

    generatePreview();

    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [paymentHistoryObj]);

  const statusClosedVal =
    (tradeDetailsbyId?.destTradeStatus === "CLOSED" &&
      paymentHistoryObj?.inOutWard === "INWARD") ||
    (tradeDetailsbyId?.srcTradeStatus === "CLOSED" &&
      paymentHistoryObj?.inOutWard === "OUTWARD") ||
    tradeDetailsbyId?.tradeStatus === "CLOSED";

  const { handleSubmitMovePayment } = useMovePayment();

  return (
    <div>
      <div className="flex pb-2">
        <div
          className="grow-[4] overflow-y-auto"
          style={{
            height: "calc(100vh - 8rem)",
            width: "100%",
          }}
        >
          {arrivalpmtHistory ? (
            <>
              <TransportPmtHistoty />
            </>
          ) : (
            <>
              <div className="flex pb-2 bg-white outlet_padding border rounded-lg m-4 items-center">
                <img src={user} className="w-12 h-12 br-100" alt="" />
                <div className="ml-2 flex flex-col">
                  <span className="font-semibold fs-14">
                    {paymentHistoryObj?.inOutWard === "INWARD" ? "From" : "To"}{" "}
                    :{" "}
                    {paymentHistoryObj?.inOutWard === "INWARD"
                      ? paymentHistoryObj?.source === "GROMOR"
                        ? "Gromor Finance Private Limited"
                        : tradeDetailsbyId?.destTradeName
                      : tradeDetailsbyId?.srcTradeName}
                  </span>
                  {paymentHistoryObj?.source === "GROMOR" ? (
                    ""
                  ) : (
                    <span className="fs-12 color-sub-text">
                      Trader-
                      {paymentHistoryObj?.inOutWard === "INWARD"
                        ? tradeDetailsbyId?.destPartyId
                        : tradeDetailsbyId?.srcPartyId}{" "}
                      |{" "}
                      {getMaskedMobileNumber(
                        paymentHistoryObj?.inOutWard === "INWARD"
                          ? tradeDetailsbyId?.destMobile || ""
                          : tradeDetailsbyId?.srcMobile || "",
                      )}
                    </span>
                  )}
                </div>
              </div>

              <div className="border p-4 br-10 m-4 bg-white h-auto">
                {paymentHistoryObj?.payoutId != null ? (
                  <div className="flex border-b py-3 justify-between">
                    <div className="flex flex-col">
                      <span className="fs-12 color-sub-text">Payout ID</span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.payoutId}
                      </p>
                    </div>
                    <div className="flex flex-col">
                      <span className="fs-12 color-sub-text">
                        {paymentHistoryObj?.inOutWard === "INWARD"
                          ? "Collection Account"
                          : "Fund Account ID"}
                      </span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.fundAccId ?? "-"}
                      </p>
                    </div>
                    <div className="flex flex-col"></div>
                  </div>
                ) : paymentHistoryObj?.inOutWard === "OUTWARD" ? (
                  <div className="flex border-b py-3 w-[100%]">
                    <div className="flex flex-col w-[33%]">
                      <span className="fs-12 color-sub-text">
                        Payment Status
                      </span>
                      <span className="font-semibold fs-14">
                        <span
                          className={`${getPaymentStatusColor(
                            paymentHistoryObj?.pmtStatus,
                          )}`}
                        >
                          <span className="font-semibold fs-14">
                            {getPaymentStatus(paymentHistoryObj?.pmtStatus)}
                          </span>
                        </span>
                      </span>
                    </div>

                    <div className=" flex flex-col pt-2 md:pt-0">
                      <span className="fs-12 color-sub-text">Date</span>
                      <p className="font-semibold fs-14">
                        {moment(paymentHistoryObj?.date).format("DD-MMM-YYYY")}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    <div className="flex border-b py-3">
                      <div className="flex flex-col w-[33%]">
                        <span className="fs-12 color-sub-text">
                          Payment Status
                        </span>
                        <span className="font-semibold fs-14">
                          {paymentHistoryObj?.pmtStatus ? (
                            paymentHistoryObj?.pmtStatus === "ACCEPTED" ? (
                              <span className="color-primary">Approved</span>
                            ) : paymentHistoryObj?.pmtStatus === "PENDING" ? (
                              <span className="color-orange">
                                Approval pending
                              </span>
                            ) : paymentHistoryObj?.pmtStatus === "CANCELLED" ? (
                              <span className="color-red">Cancelled</span>
                            ) : (
                              paymentHistoryObj?.pmtStatus === "ACCEPTED"
                            )
                          ) : (
                            "-"
                          )}
                        </span>
                      </div>
                      <div className=" flex flex-col pt-2 md:pt-0">
                        <span className="fs-12 color-sub-text">Date</span>
                        <p className="font-semibold fs-14">
                          {moment(paymentHistoryObj?.date).format(
                            "DD-MMM-YYYY",
                          )}
                        </p>
                      </div>
                    </div>

                    {selectedPaymentType == "INWARD" &&
                      paymentHistoryObj?.pmtStatus == "CANCELLED" && (
                        <div className="border-b py-3">
                          <div className="flex flex-col w-[100%]">
                            <span className="fs-12 color-sub-text">
                              Reason for Rejection
                            </span>
                            <span className="font-semibold fs-14">
                              {paymentHistoryObj?.rejectedReason}
                            </span>
                          </div>
                        </div>
                      )}

                    {selectedPaymentType == "INWARD" &&
                      paymentHistoryObj?.pmtStatus == "CANCELLED" && (
                        <div className="border-b py-3">
                          <div className="flex flex-col w-[100%]">
                            {paymentHistoryObj?.addtComments && (
                              <span className="fs-12 color-sub-text">
                                Additional Comments
                              </span>
                            )}
                            <span className="font-semibold fs-14">
                              {paymentHistoryObj?.addtComments}
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                )}
                <div className="flex border-b py-3 justify-between">
                  <div className="flex  flex-col w-[100%]">
                    <span className="fs-12 color-sub-text">
                      {selectedPaymentType == "INWARD" ||
                      paymentHistoryObj?.pmtStatus === "REFUNDED"
                        ? "Amount Received"
                        : "Amount Paid"}
                    </span>
                    <span className="font-semibold fs-14">
                      {enableExcessPayment(paymentHistoryObj?.pmtType) &&
                      selectedPaymentType == "INWARD"
                        ? getCurrencyNumberWithSymbol(
                            paymentHistoryObj?.amtRcvd,
                            true,
                          )
                        : getCurrencyNumberWithSymbol(
                            paymentHistoryObj?.amount,
                            true,
                          )}
                    </span>
                  </div>

                  {paymentHistoryObj?.payoutId ? (
                    <div className="flex flex-col w-[100%]">
                      <span className="fs-12 color-sub-text">Fees</span>
                      <span className="font-semibold fs-14">
                        {getCurrencyNumberWithSymbol(
                          paymentHistoryObj?.fees,
                          true,
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-col w-[100%]">
                      <span className="fs-12 color-sub-text">
                        {selectedPaymentType == "INWARD"
                          ? "Received Till Date"
                          : "Paid Till Date"}
                      </span>
                      <span className="font-semibold fs-14">
                        {selectedPaymentType == "OUTWARD" &&
                          getCurrencyNumberWithSymbol(
                            tradeDetailsbyId?.outwardPmt,
                            true,
                          )}
                        {selectedPaymentType == "INWARD" &&
                          getCurrencyNumberWithSymbol(
                            tradeDetailsbyId?.inwardPmt,
                            true,
                          )}
                      </span>
                    </div>
                  )}

                  {paymentHistoryObj?.payoutId ? (
                    <div className="flex flex-col w-[100%]">
                      <span className="fs-12 color-sub-text">Tax</span>
                      <span className="font-semibold fs-14">
                        {getCurrencyNumberWithSymbol(
                          paymentHistoryObj?.tax,
                          true,
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-col w-[100%]">
                      <span className="fs-12 color-sub-text">
                        {selectedPaymentType == "INWARD"
                          ? "Balance Receivable"
                          : "Balance Payable"}
                      </span>
                      <p className="font-semibold fs-14">
                        {" "}
                        {selectedPaymentType === "INWARD"
                          ? getCurrencyNumberWithSymbol(
                              (Number(tradeDetailsbyId?.totalPayable) +
                                Number(tradeDetailsbyId?.destPf) -
                                Number(tradeDetailsbyId?.destDis) || 0) -
                                (tradeDetailsbyId?.inwardPmt || 0) +
                                Number(tradeDetailsbyId?.destDelayCharges),
                              true,
                            )
                          : getCurrencyNumberWithSymbol(
                              (() => {
                                const finalPayable =
                                  Number(
                                    tradeDetailsbyId?.totalReceivable || 0,
                                  ) -
                                  Number(tradeDetailsbyId?.srcPf || 0) +
                                  Number(tradeDetailsbyId?.srcDis || 0) -
                                  Number(tradeDetailsbyId?.outwardPmt || 0);

                                const refunded = refundedTotal || 0;

                                const finalAmount =
                                  finalPayable < 0
                                    ? -(Math.abs(finalPayable) - refunded)
                                    : finalPayable - refunded;

                                return finalAmount;
                              })(),
                              true,
                            )}
                      </p>
                    </div>
                  )}
                </div>

                {selectedPaymentType == "INWARD" &&
                  enableExcessPayment(paymentHistoryObj?.pmtType) && (
                    <div className="flex border-b justify-between py-3">
                      <div className="flex flex-col w-[100%]">
                        <span className="fs-12 color-sub-text">
                          Trade Payment
                        </span>
                        <p className="font-semibold fs-14">
                          {getCurrencyNumberWithSymbol(
                            paymentHistoryObj?.amount,
                            true,
                          )}
                        </p>
                      </div>
                      <div className="flex flex-col w-[100%]">
                        <span className="fs-12 color-sub-text">
                          Moved To Wallet
                        </span>
                        <p className="font-semibold fs-14">
                          {getCurrencyNumberWithSymbol(
                            paymentHistoryObj?.waAmount,
                            true,
                          )}
                        </p>
                      </div>
                      <div className="flex flex-col w-[100%]"></div>
                    </div>
                  )}
                <div className="flex border-b justify-between py-3">
                  <div className="flex flex-col w-[100%]">
                    <span className="fs-12 color-sub-text">Payment Type</span>
                    <p className="font-semibold fs-14">
                      {paymentHistoryObj?.pmtType}
                    </p>
                  </div>
                  <div className="flex flex-col w-[100%]">
                    <span className="fs-12 color-sub-text">Mode </span>
                    <p className="font-semibold fs-14">
                      {paymentHistoryObj?.pmtMode}
                    </p>
                  </div>
                  <div className="flex flex-col w-[100%]">
                    {selectedPaymentType == "OUTWARD" && (
                      <div className="flex flex-col w-[100%]">
                        <span className="fs-12 color-sub-text">UTR Number</span>
                        <span className="font-semibold fs-14">
                          {paymentHistoryObj?.utr || "-"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={`flex ${
                    paymentHistoryObj?.accHolderName || paymentHistoryObj?.accNo
                      ? "border-b py-3"
                      : ""
                  } justify-between gap-4 w-[100%]`}
                >
                  {paymentHistoryObj?.accHolderName && (
                    <div className="flex flex-col w-[50%]">
                      <span className="fs-12 color-sub-text">
                        Account Holder Name
                      </span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.accHolderName}
                      </p>
                    </div>
                  )}

                  {paymentHistoryObj?.accNo && (
                    <div className="flex flex-col w-[50%]">
                      <span className="fs-12 color-sub-text">
                        Account Number
                      </span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.accNo}
                      </p>
                    </div>
                  )}
                </div>

                <div className="flex flex-col py-3">
                  <span className="fs-12 color-sub-text">Comments</span>
                  <p className="font-semibold fs-14">
                    {paymentHistoryObj?.comments || "-"}
                  </p>
                </div>
                {paymentHistoryObj?.payoutId && (
                  <div>
                    <div className="py-3 border-b">
                      <span className="fs-12 color-sub-text">Note 1</span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.note1 || "-"}
                      </p>
                    </div>
                    <div className="py-3 border-b">
                      <span className="fs-12 color-sub-text">Note 2</span>
                      <p className="font-semibold fs-14">
                        {paymentHistoryObj?.note2 || "-"}
                      </p>
                    </div>
                  </div>
                )}

                {paymentHistoryObj?.addtComments && (
                  <div className="pb-3 flex flex-col">
                    <span className="fs-12 color-sub-text">
                      Additional Comments
                    </span>
                    <span className="fs-14">
                      {paymentHistoryObj?.addtComments ?? "-"}
                    </span>
                  </div>
                )}

                {paymentHistoryObj?.images &&
                  paymentHistoryObj?.images?.length !== 0 && (
                    <div className="flex flex-col border-t">
                      <>
                        {" "}
                        <div className="pt-2 fs-12 color-sub-text mb-2">
                          Uploaded Documents
                        </div>
                        <div className="pb-2 flex gap-4 overflow-x-auto hide-scroll-bar">
                          {paymentHistoryObj?.images &&
                            paymentHistoryObj?.images?.length !== 0 &&
                            paymentHistoryObj?.images.map((file, i) => (
                              <div key={`receipt-document-${i}`}>
                                <div
                                  key={`receipt-document-${i}`}
                                  className="relative flex-shrink-0"
                                  style={{ width: "130px", height: "100px" }}
                                >
                                  <a
                                    href={file.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="block w-full h-full border-2 rounded p-2 overflow-hidden cursor-pointer"
                                  >
                                    <DocumentPreViewer
                                      docType={file.docType}
                                      url={file.url}
                                    />
                                  </a>
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    </div>
                  )}

                {selectedPaymentType === "OUTWARD" &&
                  paymentHistoryObj?.payoutId &&
                  (paymentHistoryObj?.pmtStatus === "ACCEPTED" ||
                    paymentHistoryObj?.pmtStatus === "REFUNDED") && (
                    <div className="mt-3">
                      <span className="fs-12 color-sub-text mb-2">
                        Payment Receipt
                      </span>
                      <PDFDownloadLink
                        document={
                          <PaymentRecDocs
                            details={paymentHistoryObj}
                            type={""}
                            status={"single"}
                            seqId={tradeId}
                          />
                        }
                        fileName="paymentreceipt.pdf"
                      >
                        <div className="flex gap-2 items-center">
                          {previewUrl ? (
                            <div className="relative">
                              {" "}
                              <a
                                href={previewUrl}
                                download="paymentreceipt.pdf"
                                target="_blank"
                                style={{ width: "200px", height: "200px" }}
                              >
                                <iframe
                                  src={previewUrl}
                                  width="200"
                                  height="200"
                                  className="border relative"
                                />

                                <img
                                  src={download}
                                  className="absolute top-3 right-3"
                                  alt=""
                                />
                              </a>
                            </div>
                          ) : (
                            <span></span>
                          )}
                        </div>
                      </PDFDownloadLink>
                    </div>
                  )}
              </div>
            </>
          )}

          {/* confirm receiptt */}
          {paymentHistoryObj?.pmtStatus != null &&
            (paymentHistoryObj?.pmtStatus === "ACCEPTED" ||
              paymentHistoryObj?.pmtStatus === "CANCELLED") &&
            selectedPaymentType === "INWARD" &&
            !arrivalpmtHistory && (
              <div className="border-gray rounded-lg m-4 bg-white">
                <div
                  className={`py-4 px-4 fs-14 font-semibold rounded-t-lg`}
                  style={{
                    background: "#EBFFF0",
                  }}
                >
                  Confirm Receipt
                </div>
                <div className="px-4 py-2 rounded-b-lg">
                  {" "}
                  <div className="flex fs-14 border-b py-3 w-[100%]">
                    <div className="flex flex-col w-[40%]">
                      <span className="fs-12 color-sub-text">
                        Payment Receipt Date
                      </span>
                      <span className="font-semibold fs-14">
                        {paymentHistoryObj?.pmtReceiptDate
                          ? moment(paymentHistoryObj?.pmtReceiptDate).format(
                              "DD-MMM-YYYY",
                            )
                          : "-"}
                      </span>
                    </div>
                    <div className="flex flex-col w-[50%]">
                      <span className="fs-12 color-sub-text">UTR Number</span>
                      <span className="font-semibold fs-14">
                        {paymentHistoryObj?.utr || "-"}
                      </span>
                    </div>
                  </div>
                  <div className="flex py-3 justify-between">
                    <div className="flex flex-col">
                      <span className="fs-12 color-sub-text">
                        Receipt ID / Description
                      </span>
                      <span className="font-semibold fs-14">
                        {paymentHistoryObj?.desc || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {/* confirm receiptt */}
          {/* {paymentHistoryObj?.pmtStatus != null &&
            paymentHistoryObj?.pmtStatus === "PENDING" &&
            selectedPaymentType === "INWARD" &&
            !arrivalpmtHistory && (
              <div className="border-gray br-10 m-4 mb-4">
                <div
                  className={`py-3 px-4 fs-14 font-semibold rounded-t-lg`}
                  style={{
                    background: "#EBFFF0",
                  }}
                >
                  Confirm Receipt
                </div>
                <div className="px-4 py-2 bg-white w-full">
                  {" "}
                  <div className="flex py-3 gap-4">
                    <div className="w-[50%]">
                      <span className="font-semibold fs-14">
                        Payment Receipt Date<span className="color-red">*</span>
                      </span>
                      <SelectDate
                        onChange={handlePaymentReceiptDate}
                        selectedDate={pmtReceiptDate}
                      />
                    </div>

                    <div className="w-[50%]">
                      <Input
                        type="text"
                        required={true}
                        label={"UTR Number"}
                        value={utr}
                        onChange={(e) => setUtr(e.target.value)}
                        inputStyle={{ marginTop: "10px" }}
                      />
                    </div>
                  </div>
                  <div className="flex py-3 flex-col">
                    <span className="fs-14">Description </span>
                    <Input
                      value={paymentDesc}
                      onChange={(e) => sertpaymentDesc(e.target.value)}
                      className="w-[100%]"
                    />
                  </div>
                  {role == "ADMIN" && (
                    <div className="flex justify-end pb-2">
                      {" "}
                      <Button
                        variant="contained"
                        className=""
                        onClick={() => {
                          savePaymentReceipt();
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )} */}
        </div>
        {hasAdminManagerEditAccess &&
          !statusClosedVal &&
          !(
            paymentHistoryObj?.inOutWard === "OUTWARD" &&
            paymentHistoryObj?.payoutId !== null
          ) &&
          tradeDetailsbyId?.tradeStatus !== "CANCELLED" && (
            <div
              className={`md:w-50 flex flex-row md:flex-col ${
                tradeDetailsbyId?.freightDtls?.paidTo !== "ONO"
                  ? "border-l p-4 gap-3 w-15"
                  : ""
              } md:gap-0 absolute md:relative bottom-0 border-t md:border-t-none justify-between md:justify-start`}
            >
              {!arrivalpmtHistory && (
                <button
                  onClick={() => {
                    onEdit(false);
                    dispatch(
                      updateEditAdvPayment({ editAdvancePayment: true }),
                    );
                    dispatch(clearArrivalDocs());
                  }}
                  className="flex flex-col justify-center items-center"
                >
                  <img src={edit} className="cursor-pointer w-8" alt="" />
                  <span className="fs-14 font-semibold">Edit</span>
                </button>
              )}

              {arrivalpmtHistory &&
                tradeDetailsbyId?.freightDtls?.paidTo !== "ONO" && (
                  <button
                    onClick={() => {
                      dispatch(setOpenArrivalPmtEdit(true));
                      dispatch(clearArrivalDocs());
                    }}
                    className="flex flex-col justify-center items-center"
                  >
                    <img src={edit} className="cursor-pointer w-8" alt="" />
                    <span className="fs-14 font-semibold">Edit</span>
                  </button>
                )}

              {!arrivalpmtHistory &&
                paymentHistoryObj?.pmtStatus !== "CANCELLED" &&
                tradeDetailsbyId?.destTradeStatus !== "CLOSED" &&
                paymentHistoryObj?.inOutWard === "INWARD" && (
                  <button
                    onClick={() => {
                      dispatch(setIsPaymentHistoryMove(true));
                      dispatch(resetMovePayment());
                    }}
                    className="flex mt-5 flex-col justify-center items-center"
                  >
                    <img src={move} className="cursor-pointer w-8" alt="" />
                    <span className="fs-14 font-semibold">Move</span>
                  </button>
                )}

              {paymentHistoryObj?.pmtStatus !== "CANCELLED" &&
                !arrivalpmtHistory && (
                  <button
                    className="mt-5 flex flex-col justify-center items-center"
                    onClick={() => {
                      setCancelPopup(true);
                    }}
                  >
                    <img src={cancel} className="cursor-pointer w-8" alt="" />
                    <span className="fs-14 font-semibold">Cancel</span>
                  </button>
                )}
            </div>
          )}
      </div>

      <>
        <Modal
          open={isPaymentHistoryMove}
          onClose={() => {
            dispatch(setIsPaymentHistoryMove(false));
          }}
          width={isMobile ? "100%" : "30vw"}
        >
          <>
            <ModalHeader title={"Move Payment"} content={<></>} />
            <div className="card_space_18">
              <MovePayment />
            </div>
            <div className="flex items-center bottom-0 right-0 px-4 py-4 border-top gap-2">
              <Button
                variant="gray"
                className="w-full"
                text="Cancel"
                onClick={() => {
                  dispatch(setIsPaymentHistoryMove(false));
                }}
              />
              <Button
                variant="contained"
                className="w-full"
                text="Move"
                onClick={() => {
                  handleSubmitMovePayment();
                }}
              />
            </div>
          </>
        </Modal>
      </>

      <>
        <Modal
          open={cancelPopup}
          onClose={() => {
            setCancelPopup(false);
          }}
          width={isMobile ? "100%" : "30vw"}
        >
          <>
            <ModalHeader
              title={"Receipt Status: Cancel Payment"}
              content={<></>}
            />
            <div className="card_space_18">
              <div className="">
                <span className="fs-14 ">
                  Reason for Cancellation
                  <span className="color-red">*</span>
                </span>
                <Select2
                  value={cancellationReason}
                  lable=""
                  options={[
                    {
                      label: "Duplicate Entry",
                      value: "Duplicate Entry",
                    },
                    {
                      label: "Invalid Receipt",
                      value: "Invalid Receipt",
                    },
                    {
                      label: "Payment not Received",
                      value: "Payment not Received",
                    },
                  ]}
                  onChange={(selectedReason) => {
                    setCancellationReason(selectedReason.value);
                  }}
                  classNames="mt-[9px]"
                />
              </div>
              <div className="mt-[12px]">
                <span className="fs-14">Additional Comments</span>
                <div className="pt-[9px]">
                  <textarea
                    value={additionalComments}
                    onChange={(e) => {
                      setAdditionalComments(e.target.value);
                    }}
                    className="h-[200px] w-[100%] p-2 border border-gray br-10"
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center bottom-0 right-0 px-4 py-4 border-top gap-2">
              <Button
                variant="gray"
                className="w-full"
                text="Cancel"
                onClick={() => {
                  setCancelPopup(false);
                }}
              />
              <Button
                variant="contained"
                className="w-full"
                text="Save"
                onClick={() => {
                  cancelRecordPayment();
                }}
              />
            </div>
          </>
        </Modal>
      </>

      <>
        <PanelSlider
          direction={"right_to_left"}
          open={openTransportPmtEdit}
          onClose={() => {
            dispatch(setOpenArrivalPmtEdit(false));
          }}
          style={{ width: "40vw" }}
          zIndex={100}
        >
          <div
            // ref={panelRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <div className="py-6 px-4 border-b flex items-center justify-between">
              <div>
                <span className="text-base font-semibold">
                  Record Receivable
                </span>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  className="cursor-pointer"
                  alt=""
                  onClick={() => {
                    dispatch(setOpenArrivalPmtEdit(false));
                  }}
                />
              </div>
            </div>

            {openTransportPmtEdit && (
              <div className="bg-gray-bg">
                <TransportPmtEdit />
              </div>
            )}
          </div>
        </PanelSlider>
      </>
    </div>
  );
};
export default PaymentHistory;
